import { createContext, useContext, useEffect, useMemo, useState, } from "react";
import { styled, ThemeProvider } from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import { cacheRtl, lightTheme } from "../ui/Theme";
import { CssBaseline } from "@mui/material";
import { getCookie } from "../lib/dashboard/actions";
import useSWR from "swr";
import { fetchData } from "../lib/dashboard/data";

export const MainLayoutContext = createContext();

const MainLayoutProvider = ({ children }) => {
    const [mode, setMode] = useState("light");
    const [isLoading, setIsLoading] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [fullname, setFullname] = useState("");
    const authToken = getCookie("authToken");

    const FieldsetBox = styled("fieldset")({
        display: "flex",
        border: mode === "light" ? "1px solid #DBDEE1" : "1px solid #515151",
        flexDirection: "column",
        gap: 10,
        borderRadius: 4,
    });

    // get user subscription data
    const {
        data: subscriptionData,
        isValidating: subscriptionIsValidating,
        isLoading: subscriptionIsLoading,
    } = useSWR(authToken && "/account/subscriptions", fetchData, {
        revalidateOnFocus: false,
        errorRetryCount: 0,
    })

    // set name from cookie
    useEffect(() => {
        const name = getCookie("username");
        setFullname(name);
    }, []);

    //background info color for highlight
    const bgInfoColor = useMemo(() => {
        return mode === "dark" ? "#0288d1" : "#4fc3f7";
    }, [mode]);

    return (
        <MainLayoutContext.Provider
            value={{
                fullname,
                setFullname,
                subscriptionData,
                subscriptionIsValidating,
                subscriptionIsLoading,
                isLoading,
                setIsLoading,
                mode,
                setMode,
                bgInfoColor,
                sidebarOpen,
                setSidebarOpen,
                FieldsetBox,
            }}
        >
            <CacheProvider value={cacheRtl}>
                <ThemeProvider theme={lightTheme}>
                    <CssBaseline />
                    {children}
                </ThemeProvider>
            </CacheProvider>
        </MainLayoutContext.Provider>
    );
};

export default MainLayoutProvider;

export const useMainLayoutContext = () => useContext(MainLayoutContext);
